__turbopack_context__.v({
  "fade-in": "Skeleton-module-scss-module__Dbyqfq__fade-in",
  "no-transform": "Skeleton-module-scss-module__Dbyqfq__no-transform",
  "rotate": "Skeleton-module-scss-module__Dbyqfq__rotate",
  "skeleton": "Skeleton-module-scss-module__Dbyqfq__skeleton",
  "skeletonCircle": "Skeleton-module-scss-module__Dbyqfq__skeletonCircle",
});
